module.exports = __webpack_public_path__ + "static/img/ll04.9e31652.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ll04.png
// module id = 44vg
// module chunks = 0